import AvantiStopsDot from "./AvantiStopsDot";

export default AvantiStopsDot;
